import React from 'react'
import * as Icon from 'react-feather'


function Footer() {
    const currentYear = new Date().getFullYear();
  return (
    <div className='footer'>
        <div className='footer-wrapper'>
            <div className='social-icons'>
                <p>Follow us on:</p>
                <div>
                    <a href='https://www.facebook.com/ghalo.ovie' target='_blank' rel='noopener noreferrer'><Icon.Facebook /></a>
                    <a href='https://twitter.com/oviemerlo' className='twitter' target='_blank' rel='noopener noreferrer'><Icon.Twitter /></a>
                    <a href='https://www.youtube.com/channel/UCYg_so1PPRY_VrfRcluoRKw' className='youtube' target='_blank' rel='noopener noreferrer'><Icon.Youtube /></a>
                    <a href='https://www.instagram.com/briggs_flavours24_7/' className='instagram' target='_blank' rel='noopener noreferrer'><Icon.Instagram /></a>

                </div>
            </div>
            <div className='contact-info'>
                <Icon.Phone />+1 (437) 419 - 5600
            </div>
            <div className='address'>
                <p className='street'><Icon.MapPin />
                    2215 - 339 Rathburn Road West </p>
                    <p className='city'>Mississauga ON.</p>
                    <p className='postal'>L5B 0K6</p>
                
                
            </div>
            <div className='copyright'>
                &copy; {currentYear} www.briggsflavours.com. All rights reserved.
            </div>

        </div>

    </div>
  )
}

export default Footer